import React from 'react'

import PropTypes from 'prop-types'

import './session--card.css'

const SessionCCard = (props) => {
  return (
    <div className={`services-card ${props.rootClassName} `}>
      <div className="session--card-container">
        <img
          alt={props.image_alt}
          src={props.image_src}
          className="session--card-image"
        />
      </div>
      <div className="session--card-container1">
        <span className="session--card-text">{props.text}</span>
        <ol className="list session--card-ul">
          <li className="list-item">
            <span className="">
              <span className="">up to 6 pax</span>
              <br className=""></br>
            </span>
          </li>
          <li className="list-item">
            <span className="">30 mins photo session</span>
          </li>
          <li className="list-item">
            <span className="">20 mins photo selection</span>
          </li>
          <li className="list-item">
            <span className="">3 backdrop color</span>
          </li>
          <li className="list-item">
            <span className="">4 pcs. postcard prints</span>
          </li>
          <li className="list-item">
            <span className="">4 pcs. photo strips</span>
          </li>
          <li className="list-item">
            <span className="">all digital copies (JPEG)</span>
          </li>
        </ol>
      </div>
      <h4 className="session--card-text12">{props.text2}</h4>
    </div>
  )
}

SessionCCard.defaultProps = {
  text2: 'Php950',
  image_src: '/website-200h.png',
  image_alt: 'image',
  text: 'Session C',
  rootClassName: '',
}

SessionCCard.propTypes = {
  text2: PropTypes.string,
  image_src: PropTypes.string,
  image_alt: PropTypes.string,
  text: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default SessionCCard
